module.exports = __webpack_public_path__ + "static/media/PS-logo.937424e5.svg";